import * as immutable from 'object-path-immutable';
import * as types from './actionTypes';

const getIndexOfGoodToUpdate = (list, id) => {
  return list.findIndex(good => good.id === id);
};

const initialState = {
  products: {
    categoriesAliases: {},
    categories: [],
    list: [],
    isLoading: false,
    isLoaded: false,
    hasError: false,
  },
  ingredients: {
    list: [],
    isLoading: false,
    isLoaded: false,
    hasError: false,
  },
  pizzaFilter: {
    activeIngredients: {},
    isLoading: false,
    isLoaded: false,
    hasError: false,
  },
  upsale: {
    items: null,
    stockCode: null,
  },
};

export default function catalogReducer(state = initialState, action) {
  switch (action.type) {
    case types.REMOVE_INGREDIENT: {
      const indexOfGoodToUpdate = getIndexOfGoodToUpdate(state.products.list, action.payload.id);
      const indexOfVariationToUpdate = state.products.list[
        indexOfGoodToUpdate
      ].variations.findIndex(variation => variation.id === action.payload.variationId);

      return immutable.update(
        state,
        [
          'products',
          'list',
          indexOfGoodToUpdate,
          'variations',
          indexOfVariationToUpdate,
          'include_ingredients',
        ],
        ingredients => {
          const indexOfIngredientToUpdate = ingredients.findIndex(
            ingredient => ingredient.id === action.payload.ingredientId,
          );
          return immutable.update(ingredients, [indexOfIngredientToUpdate], ingredient =>
            immutable.set(ingredient, 'removed', !ingredient.removed),
          );
        },
      );
    }

    case types.CANCEL_REMOVED_INGREDIENTS: {
      const indexOfGoodToUpdate = getIndexOfGoodToUpdate(state.products.list, action.payload.id);
      const indexOfVariationToUpdate = state.products.list[
        indexOfGoodToUpdate
      ].variations.findIndex(variation => variation.id === action.payload.variationId);

      return immutable.update(
        state,
        [
          'products',
          'list',
          indexOfGoodToUpdate,
          'variations',
          indexOfVariationToUpdate,
          'include_ingredients',
        ],
        ingredients =>
          (ingredients || []).map(ingredient => immutable.set(ingredient, 'removed', false)),
      );
    }

    case types.RESET_GOOD: {
      const indexOfGoodToUpdate = getIndexOfGoodToUpdate(state.products.list, action.payload.id);

      return immutable.assign(state, ['products', 'list', indexOfGoodToUpdate], {
        isLoading: false,
        isLoaded: false,
        isAdded: false,
        isAdding: false,
        error: '',
      });
    }

    case types.CHANGE_DOUGH: {
      const indexOfGoodToUpdate = getIndexOfGoodToUpdate(state.products.list, action.payload.id);

      return immutable.assign(state, ['products', 'list', indexOfGoodToUpdate], {
        currentDough: action.payload.doughType,
      });
    }

    case types.CHANGE_SIZE: {
      const indexOfGoodToUpdate = getIndexOfGoodToUpdate(state.products.list, action.payload.id);

      return immutable.assign(state, ['products', 'list', indexOfGoodToUpdate], {
        currentSize: action.payload.size,
      });
    }

    case types.TOGGLE_STUFFED_CRUST:
    case types.SELECT_STUFFED_CRUST: {
      const indexOfGoodToUpdate = getIndexOfGoodToUpdate(state.products.list, action.payload.id);

      return immutable.assign(state, ['products', 'list', indexOfGoodToUpdate], {
        stuffedCrustIsAdd: action.payload.value !== 'none',
        stuffedCrust: action.payload.value,
      });
    }

    //

    case types.FETCH_GOODS_REQUEST:
      return immutable.assign(state, 'products', {
        isLoading: true,
        isLoaded: false,
        hasError: false,
      });

    case types.FETCH_GOODS_SUCCESS: {
      let list = [];
      let categoriesAliases = {};

      const categories = action.payload.map(category => {
        const { goods, ...otherProps } = category;

        list = list.concat(category.goods);
        categoriesAliases = { ...categoriesAliases, [category.alias]: category.name };

        return otherProps;
      });

      return immutable.assign(state, 'products', {
        isLoading: false,
        isLoaded: true,
        list,
        categoriesAliases,
        categories,
      });
    }

    case types.FETCH_GOODS_FAILURE:
      return immutable.assign(state, 'products', {
        isLoading: false,
        isLoaded: false,
        hasError: true,
      });

    //

    case types.FETCH_GOOD_REQUEST: {
      const good = {
        id: action.payload.id,
        isLoading: true,
        isLoaded: false,
      };

      return immutable.push(state, ['products', 'list'], good);
    }

    case types.FETCH_GOOD_SUCCESS: {
      const indexOfGoodToUpdate = getIndexOfGoodToUpdate(state.products.list, action.payload.id);

      return immutable.assign(state, ['products', 'list', indexOfGoodToUpdate], {
        ...action.payload.data,
        isLoading: false,
        isLoaded: true,
      });
    }

    case types.FETCH_GOOD_FAILURE: {
      const indexOfGoodToUpdate = getIndexOfGoodToUpdate(state.products.list, action.payload.id);

      return immutable.assign(state, ['products', 'list', indexOfGoodToUpdate], {
        ...action.payload.data,
        isLoading: false,
        isLoaded: false,
        error: action.payload.error,
      });
    }

    //

    case types.ADD_TO_CART_REQUEST: {
      const indexOfGoodToUpdate = getIndexOfGoodToUpdate(state.products.list, action.payload);

      return immutable.assign(state, ['products', 'list', indexOfGoodToUpdate], {
        isAdded: false,
        isAdding: true,
        error: '',
      });
    }

    case types.ADD_TO_CART_SUCCESS: {
      const indexOfGoodToUpdate = getIndexOfGoodToUpdate(state.products.list, action.payload);

      return immutable.assign(state, ['products', 'list', indexOfGoodToUpdate], {
        isAdding: false,
        isAdded: true,
        error: '',
      });
    }

    case types.ADD_TO_CART_FAILURE: {
      const indexOfGoodToUpdate = getIndexOfGoodToUpdate(state.products.list, action.payload.id);

      return immutable.assign(state, ['products', 'list', indexOfGoodToUpdate], {
        isAdded: false,
        isAdding: false,
        error: action.payload.error,
      });
    }

    //

    case types.FETCH_INGREDIENTS_REQUEST:
      return immutable.assign(state, 'ingredients', {
        isLoading: true,
        isLoaded: false,
        hasError: false,
      });

    case types.FETCH_INGREDIENTS_SUCCESS:
      return immutable.assign(state, 'ingredients', {
        isLoading: false,
        isLoaded: true,
        list: action.payload,
      });

    case types.FETCH_INGREDIENTS_FAILURE:
      return immutable.assign(state, 'ingredients', {
        isLoading: false,
        isLoaded: false,
        hasError: true,
      });

    case types.FETCH_PIZZAFILTER_REQUEST:
      return immutable.assign(state, 'pizzaFilter', {
        isLoading: true,
        isLoaded: false,
        hasError: false,
      });

    case types.FETCH_PIZZAFILTER_SUCCESS:
      return immutable.assign(state, 'pizzaFilter', {
        isLoading: false,
        isLoaded: true,
        activeIngredients: action.payload,
      });

    case types.FETCH_PIZZAFILTER_FAILURE:
      return immutable.assign(state, 'pizzaFilter', {
        isLoading: false,
        isLoaded: false,
        hasError: true,
      });

    case types.FETCH_UPSALE_SUCCESS: {
      return {
        ...state,
        upsale: {
          ...state.upsale,
          items: action.payload.items,
          stockCode: action.payload.stockCode || null,
        },
      };
    }

    default:
      return state;
  }
}
